import _ from 'lodash';

export function getSCLink(name, id, extension) {
  return _.join([
    'https://help.praece.com/',
    'Bin/',
    `ConnectWiseControl.ClientSetup.${extension}?`,
    'h=help.praece.com&',
    'p=8041&',
    `k=${encodeURIComponent(process.env.SC_PUBLIC_KEY)}&`,
    'e=Access&',
    'y=Guest&',
    't=&',
    `c=${encodeURIComponent(name)}&`,
    `c=${id}&`,
    'c=&',
    'c=&',
    'c=&',
    'c=&',
    'c=&',
    'c='
  ], '');
}

export function roundToQuarter(duration) {
  return _.ceil(duration * 4) / 4;
}



// WEBPACK FOOTER //
// ./app/utils/app-utils.js